import React from "react";
import { isArray } from "lodash";
import { Page } from "react-onsenui";
import {
  findReactionsFromQueries, searchReagents, searchColors
} from "../services/megamix";
import { isQueryEmpty } from "../services/megamixUtils";
import ReactionsList from "../components/analyze/ReactionsList";
import SelectQueries from "../components/analyze/SelectQueries";
import SubstancesIndex from "../components/substance/SubstancesIndex";
import Toolbar from "../components/Toolbar";
import { encodeQueries, decodeQueries } from "../services/queriesEncoder";
import { encodedQueriesToPathname, encodedQueriesToUrl, getEncodedQueriesFromUrl,
  searchToPathname, searchToUrl, getSearchTermFromUrl
 } from "../services/url";

 console.log('AnalyzePage component rendered');

 
// Only use simple colors in AnalyzePage color selections
const useSimpleColors = true;

const defaultQueries = [{ "reagentId": 1, "colorIds": [] }];

class AnalyzePage extends React.Component {
  state = {
    queries: defaultQueries,
    reactions: [],
    showReactions: true
    
  };
  initialSearchTerm = null;

  constructor(props) {
    super(props);
    // console.log('AnalyzePage constructor called');

    const encodedQueries = getEncodedQueriesFromUrl(window);
    // console.log('AnalyzePage: encodedQueries from URL:', encodedQueries);
    if (encodedQueries != null) {
      this.loadEncodedQueries(encodedQueries);
      return;
    }

    const searchTerm = getSearchTermFromUrl(window);
    // console.log('AnalyzePage: searchTerm from URL:', searchTerm);
    if (searchTerm != null) {
      this.initialSearchTerm = searchTerm;
    }
  }

  loadEncodedQueries(encodedQueries) {
    const queries = decodeQueries(encodedQueries);
    // console.log('AnalyzePage: Decoded queries:', queries);
    if (Array.isArray(queries) && queries.length > 0) {
      this.state = {
        ...this.state,
        queries
      }

      const newPathName = encodedQueriesToPathname(window, encodedQueries);
      // console.log("AnalyzePage: found encoded queries in URL", queries);
      // console.log("AnalyzePage: navigating to " + newPathName);

      setTimeout(() => {
        window.history.replaceState(
          {},
          '',
          newPathName
        );
      }, 1);
    }
  }

  loadSearchTerm(term) {
    // console.log("AnalyzePage: found search term in URL", term);
    this.setState({ initialSearchTerm: term });
  }

  componentDidMount() {
    // console.log('AnalyzePage: componentDidMount triggered');
    const newReactions = findReactionsFromQueries(
      this.state.queries,
      useSimpleColors
    );
    console.log('AnalyzePage: New reactions found:', newReactions);
  
    // Only show reactions if there are valid queries (not default or empty)
    const hasValidQueries = this.state.queries.some(query => !isQueryEmpty(query));
  
    this.setState({
      reactions: newReactions,
      // Only show reactions if valid queries exist or an initial search term exists
      showReactions: hasValidQueries && this.initialSearchTerm == null
    });
  }

  handleSearchTermChange(isActive, term, vialClicked = false) {
    // console.log("AnalyzePage: handleSearchTermChange triggered");
    // console.log("isActive:", isActive);
    // console.log("term:", term);
    // console.log("vialClicked:", vialClicked);
  
    if (vialClicked) {
      // Jeśli vial został kliknięty i showReactions jest true, przełącz na listę substancji
      if (this.state.showReactions) {
        // console.log("AnalyzePage: Hiding reactions and showing substance list.");
        this.setState({ showReactions: false });
      } else {
        // Jeśli vial został kliknięty, a reakcje są ukryte, pokaż reakcje
        // console.log("AnalyzePage: Showing reactions.");
        this.setState({ showReactions: true });
      }
    } else {
      // Jeśli wyszukiwanie jest aktywne lub vial nie został kliknięty, pokaż SubstanceIndex
      // console.log("AnalyzePage: Search is active or vial was not clicked, showing substance index.");
      this.setState({ showReactions: false });
    }
  
    if (isActive) {
      const searchPathname = searchToPathname(window, term);
      // console.log("AnalyzePage: navigating to searchPathname:", searchPathname);
      window.history.replaceState(null, null, searchPathname);
    } else {
      const previousUrl = document.analyzeQueryUrl ? document.analyzeQueryUrl : window.location.pathname;
      // console.log("AnalyzePage: resetting URL to", previousUrl);
      window.history.replaceState(null, null, previousUrl);
    }
  }

  currentSubstanceIds() {
    const { queries, reactions } = this.state;
    // console.log('AnalyzePage: currentSubstanceIds called. Queries:', queries, 'Reactions:', reactions);
    if (isArray(queries) && queries.filter(q => !isQueryEmpty(q)).length > 0) {
      return reactions.map(r => `${r.substance.id}`);
    }
    return null;
  }

  resetQueries() {
    // console.log('AnalyzePage: resetQueries triggered');
    this.setState({ queries: defaultQueries, reactions: [] });
    const newPathName = encodedQueriesToPathname(window, "");
    window.history.replaceState(null, null, newPathName);
    document.analyzeQueryUrl = newPathName;
  }

  handleQueriesChange(newQueries) {
    // console.log('AnalyzePage: handleQueriesChange triggered. New Queries:', newQueries);
    if (newQueries == null || newQueries.length == 0) {
      newQueries = defaultQueries;
    }

    const newReactions = findReactionsFromQueries(newQueries, useSimpleColors);
    // console.log('AnalyzePage: New reactions after query change:', newReactions);
    this.setState({ queries: newQueries, reactions: newReactions });

    const newPathName = encodedQueriesToUrl(window, encodeQueries(newQueries));
    // console.log("AnalyzePage: Updating URL to:", newPathName);
    window.history.replaceState(null, null, newPathName);
    document.analyzeQueryUrl = newPathName;
  }

  renderToolbar() {
    const { navigator, showMenu } = this.props;
    // console.log('AnalyzePage: renderToolbar called');
    return (
      <Toolbar
        pageName="Reagent results"
        navigator={navigator}
        showMenu={showMenu}
      />
    );
  }

  getAllSubstanceClasses() {
    const substances = getSubstances(); // Zakładam, że pobierasz substancje z serwisu
    const allClasses = substances
      .flatMap(substance => substance.info ? substance.info.classes : [])
      .filter((value, index, self) => self.indexOf(value) === index); // Usuwanie duplikatów
    return allClasses;
  }

  // If we want SelectQueries to be fixed to the top
  // renderFixed() {
  //   const { queries } = this.state;
  //   const currentSubstanceIds = this.currentSubstanceIds();
  //   return (
  //     <SelectQueries
  //       queries={queries}
  //       currentSubstanceIds={currentSubstanceIds}
  //       onQueriesChange={this.handleQueriesChange.bind(this)}
  //       onQueriesReset={this.resetQueries.bind(this)}
  //     />
  //   );
  // }



  render() {
    // console.log('AnalyzePage: render called');
    const { queries, reactions, showReactions } = this.state;
    const { navigator } = this.props;
    const nonNullQueries = queries.filter(q => !isQueryEmpty(q));
    const currentSubstanceIds = this.currentSubstanceIds();
  
    const isSubstanceIndexActive = this.state.showReactions === false && this.initialSearchTerm !== null;

    // console.log("AnalyzePage: showReactions is", showReactions);
    const showFullSubstanceList = !showReactions && !isSubstanceIndexActive;
  
    return (
      <div>
        { this.props.NoOnsen ? (
          <div>
            <SubstancesIndex
              initialSearchTerm={this.initialSearchTerm}
              onSearchTermChange={this.handleSearchTermChange.bind(this)}
              NoOnsen={this.props.NoOnsen}
              showFullList={showFullSubstanceList}
              showReactions={showReactions}  // Poprawka: Upewnij się, że przekazujesz showReactions
            />
            <hr style={{border:0}} />
            { showReactions && 
              <SelectQueries
                queries={queries}
                currentSubstanceIds={currentSubstanceIds}
                onQueriesChange={this.handleQueriesChange.bind(this)}
                onQueriesReset={this.resetQueries.bind(this)}
              />
            }
            { showReactions && 
              <ReactionsList
                NoOnsen={true}
                reactions={reactions}
                queries={queries}
                navigator={navigator}
              />
            }
          </div>
        ) : (
          <Page
            renderToolbar={this.renderToolbar.bind(this)}
          >
            <SelectQueries
              queries={queries}
              currentSubstanceIds={currentSubstanceIds}
              onQueriesChange={this.handleQueriesChange.bind(this)}
              onQueriesReset={this.resetQueries.bind(this)}
              NoOnsen={this.props.NoOnsen}
            />
            <ReactionsList
              reactions={reactions}
              queries={queries}
              navigator={navigator}
            />
  
            { !showReactions && (
              <SubstancesIndex
                onSearchTermChange={this.handleSearchTermChange.bind(this)}
                NoOnsen={this.props.NoOnsen}
                showFullList={true}
                showReactions={showReactions}  // Poprawka: przekazanie showReactions
              />
            )}
          </Page>
        )}
      </div>
    );
  }
}

export default AnalyzePage;